'use strict';

exports.__esModule = true;
exports.mediaSizes = exports.media = undefined;

var _styledComponents = require('styled-components');

var mediaSizes = {
  xl: 1920,
  lg: 1280,
  md: 960,
  sm: 600,
  xs: 0
};

// iterate through the mediaSizes and create a media template
var media = Object.keys(mediaSizes).reduce(function (accumulator, label) {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  var result = accumulator;
  var emSize = mediaSizes[label] / 16;
  result[label] = function () {
    return (0, _styledComponents.css)(['@media (min-width:', 'em){', '}'], emSize, _styledComponents.css.apply(undefined, arguments));
  };
  return result;
}, {});

exports.media = media;
exports.mediaSizes = mediaSizes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/utils/media.js
// module id = 529
// module chunks = 29